import { render, staticRenderFns } from "./HubActivities.vue?vue&type=template&id=4fecb1b4"
import script from "./HubActivities.vue?vue&type=script&lang=js"
export * from "./HubActivities.vue?vue&type=script&lang=js"
import style0 from "./HubActivities.vue?vue&type=style&index=0&id=4fecb1b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports